import * as React from 'react';
import {
    WrappedFieldProps
} from "redux-form";
import FormGroupCheckbox from "./form_group_checkbox";

interface IProps {
    label: string;
    customOnChange?: (event: any) => void;
}

const FormGroupCheckboxConnectRf: React.FC<IProps & WrappedFieldProps> = (props) => {

    const { label, input, meta, customOnChange} = props;

    const hasError = !!meta.error && !!meta.touched;

    return (
        <FormGroupCheckbox
            name={input.name}
            label={label}
            input={input}
            customOnChange={customOnChange}
            hasError={hasError}
            errorText={props.meta.error}
        />
    );
};

export default (FormGroupCheckboxConnectRf);


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_checkbox_connect_rf.tsx